import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import BudgetScenarioIcon from "@/Components/Icons/BudgetScenarioIcon";
import SuperOptimizeIcon from "@/Components/Icons/SuperOptimizeIcon";
import { Box } from "@/Components/v2/atoms/Box";
import { Stack } from "@/Components/v2/atoms/Stack";
import { BoldSpan, Typography } from "@/Components/v2/atoms/Typography";
import {
  createScenarioDescription,
  createScenarioHeader,
  forecastText,
  superOptimizeText,
} from "@/pages/scenario-builder/constants";
import { ScenarioTypeEnum } from "@/pages/scenario-builder/types";
import { CreateScenarioOptions as CreateScenarioOptionsType } from "@/pages/scenario-builder/v3/api/createScenario";
import ScenarioCard, {
  BulletPoint,
} from "@/pages/scenario-builder/v3/components/BuildScenarioCard/ScenarioCard";

interface NewScenarioDialogContentProps {
  onClick: (scenarioType: ScenarioTypeEnum, options?: CreateScenarioOptionsType) => () => void;
}

export const CreateScenarioOptions: React.FC<NewScenarioDialogContentProps> = ({ onClick }) => {
  const forecastBulletPoints: BulletPoint[] = [
    {
      text: "Take the guesswork out of media planning by validating your strategy before execution",
      icon: <CheckCircleOutlineIcon color="success" sx={{ fontSize: 20 }} />,
    },
    {
      text: "Set minimum and maximum spending limits for specific channels",
      icon: <CheckCircleOutlineIcon color="success" sx={{ fontSize: 20 }} />,
    },
    {
      text: "Automatically fill in missing data using historical trends",
      icon: <CheckCircleOutlineIcon color="success" sx={{ fontSize: 20 }} />,
    },
    {
      text: <BoldSpan>Get results fast: reports in just 10 minutes!</BoldSpan>,
      icon: <AccessTimeIcon sx={{ fontSize: 20, color: "primary.main" }} />,
    },
  ];

  const optimizeBulletPoints: BulletPoint[] = [
    {
      text: "Utilize an advanced machine learning algorithm to find the best spend distribution",
      icon: <CheckCircleOutlineIcon color="success" sx={{ fontSize: 20 }} />,
    },
    {
      text: "Set minimum and maximum spending limits for specific channels",
      icon: <CheckCircleOutlineIcon color="success" sx={{ fontSize: 20 }} />,
    },
    {
      text: "Automatically fill in missing data using historical trends",
      icon: <CheckCircleOutlineIcon color="success" sx={{ fontSize: 20 }} />,
    },
    {
      text: <BoldSpan>Get results fast: reports in just 10 minutes!</BoldSpan>,
      icon: <AccessTimeIcon sx={{ fontSize: 20, color: "primary.main" }} />,
    },
  ];

  return (
    <Box sx={{ padding: "1.5rem 0.5rem 1.5rem 0.5rem" }}>
      <Stack direction="column" justifyContent="center" alignItems="center">
        <Typography variant="h4" fontWeight={600} mb={0.5}>
          {createScenarioHeader}
        </Typography>
        <Typography variant="body1" textAlign="center" mb={4} maxWidth="45rem">
          {createScenarioDescription}
        </Typography>
        <Stack direction="row" spacing={3}>
          <ScenarioCard
            onClick={onClick(ScenarioTypeEnum.Budget)}
            icon={<BudgetScenarioIcon sx={{ color: "mutinexMagenta.main" }} />}
            title="Forecast"
            description={forecastText}
            bulletPoints={forecastBulletPoints}
          />
          <ScenarioCard
            onClick={onClick(ScenarioTypeEnum.Optimizer, {
              scenarioCount: 1000,
            })}
            icon={<SuperOptimizeIcon sx={{ color: "mutinexMagenta.main" }} />}
            title="Optimize"
            description={superOptimizeText}
            bulletPoints={optimizeBulletPoints}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default CreateScenarioOptions;
